import React from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  BaseBean,
  MasterAttributeBean,
  RestReportBean,
} from "../ds/client_ds.js";
import {
  AddressBean,
  AllCustomerTransactionGeneralRequest,
  BaseCustomerPaymentAgingHistoryBean,
  CustomerAccountSummaryBean,
  CustomerBalanceDetailHistoryCriteriaBean,
  CustomerBalanceDetailHistoryInquiryResultBean,
  CustomerBean,
  CustomerCurrentAgingMailRequest,
  CustomerPaymentAgingHistoryCriteriaBean,
  CustomerTransactionAccountSummarySearchCriteria,
  CustomerTransactionDataRequest,
  CustomerTransactionInquiryCriteria,
  CustomerTransactionSummaryCriteriaBean,
  CustomerTransactiontSummaryResultBean,
  MailInfoBean,
  PopupCustomerTransactionCreditMemoDetailsPrintRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupARModule,
  PopupCreditMemoModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerTransaction extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer transaction Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: true,
      isShowExcelButton: true,
      showModuleList: [],
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CustomerTransactionInquiryCriteria(),
      accSummaryCriteria: new CustomerTransactionAccountSummarySearchCriteria(),
      summaryCriteria: new CustomerTransactionSummaryCriteriaBean(),
      customerData: new CustomerBean(),
      addressData: new AddressBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      currencies: [],
      agingBucketList: [],
      agingHistoryBean: new BaseCustomerPaymentAgingHistoryBean(),
      accountSummary: new CustomerAccountSummaryBean(),
      customerBalanceData: new CustomerBalanceDetailHistoryInquiryResultBean(),
      customerTransactions: [],
      isShowInvoiceDetailsTable: true,
      isShowCreditMemoDetailsTable: false,
      baseBean: new BaseBean(),
      maBean: new MasterAttributeBean(),
      statusBean: new BaseBean(),
      isShowModuleList: false,
      unAppliedCMs: [],
      isShowInvoiceStatus: true,
      isShowCreditMemoStatus: false,
      isShowCustomerBalancePopup: false,
      isShowCustomerBalanceData: false,
      isShowUnAppliedCreditMemoPopup: false,
      isShowInvoiceAmountPopup: false,
      isShowInvoiceAppliedAmountPopup: false,
      isShowInvoiceAppliedCMAmountPopup: false,
      isShowCreditMemoAppliedAmountPopup: false,
      isShowInvoiceModule: false,
      isShowARModule: false,
      isShowCreditMemoModule: false,
      isShowMailPopup: false,
      mailInfoBean: new MailInfoBean(),
      isDisableFields: false,
      customerBalanceList: [],
      transactionSummaryResult: new CustomerTransactiontSummaryResultBean(),
      isShowButtons: false,
      readARAppliedList: new Array(),
      readARCreditMemoList: new Array(),
      alertMessage: "",
      isShowAlertLvl3: false,
      order: "asc",
      sortField: "",
    };
    this.currency = "USD";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let currencies = attribute_cache.currencies;
    if (currencies != null || currencies != undefined) {
      currencies.map((attr) => {
        this.state.currencies.push(attr);
      });
    }
    this.initLookupHandlers();
    this.loadPage(1);
  }
  initLookupHandlers = () => {
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  summaryOnChange = (e) => {
    let summaryCriteria = this.state.summaryCriteria;
    summaryCriteria.companyCode = this.companyCode;
    summaryCriteria[e.target.name] = e.target.value;
    this.setState({ summaryCriteria: summaryCriteria });
  };
  searchCustomers = (e) => {
    if (e.detail === 1) this.loadPage(1);
  };
  resetCustomers = (e) => {
    if (e.detail === 1) {
      let criteria = new CustomerTransactionSummaryCriteriaBean();
      criteria.companyCode = this.companyCode;
      this.state.summaryCriteria = criteria;
      this.setState({
        summaryCriteria: criteria,
        customerData: new CustomerBean(),
        addressData: new AddressBean(),
        agingHistoryBean: new BaseCustomerPaymentAgingHistoryBean(),
        accountSummary: new CustomerAccountSummaryBean(),
        customerTransactions: [],
        unAppliedCMs: [],
        isShowModuleList: [],
        isShowButtons: false,
        transactionSummaryResult: new CustomerTransactiontSummaryResultBean(),
        agingBucketList: [],
        customerBalanceList: [],
        customerBalanceData:
          new CustomerBalanceDetailHistoryInquiryResultBean(),
      });
      this.loadPage(1);
    }
  };
  loadPage = (pageNumber) => {
    let summaryCriteria = this.state.summaryCriteria;
    summaryCriteria.companyCode = this.companyCode;
    summaryCriteria.currencyCode = this.currency;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 100;
    pageInput.currentPage = pageNumber;
    let listRequest = new CustomerTransactionDataRequest();
    listRequest.criteria = summaryCriteria;
    listRequest.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerTransactionInquiryList(listRequest);
  };
  loadCustomerTransactionInquiryList = (listRequest) => {
    if (SecurityAccessManager.CustomerTransactionInquiry_IsAccessible()) {
      ReportService.getCustomerTransactionSummaryData(
        listRequest,
        this.customerTransactionInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  customerTransactionInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.customerTransactiontSummaryResult != null
    ) {
      let accountSummaryResult = [];
      if (
        response.data.customerTransactiontSummaryResult
          .customerAccountSummaryPageList != null
      ) {
        if (
          !isEmptyArray(
            response.data.customerTransactiontSummaryResult
              .customerAccountSummaryPageList.accountSummaryList
          )
        ) {
          accountSummaryResult =
            response.data.customerTransactiontSummaryResult
              .customerAccountSummaryPageList.accountSummaryList;
        }
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: accountSummaryResult,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearError = () => {};
  statusConventor = (data, type) => {
    let status = "";
    if (data == "A") {
      status = "Approved";
    } else if (data == "F") {
      status = "Paid";
    } else if (data == "X") {
      status = "Cancelled";
    } else if (data == "U") {
      status = "UnApproved";
    } else if (data == "P") {
      status = "PartiallyPaid";
    }

    if (type == 1) {
      status = status + " :: Invoice";
    } else if (type == 2) {
      status = status + " :: CreditMemo";
    }
    return status;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed, error_list: [] });
  };
  viewCustomerDetails = (e, code) => {
    if (e.detail === 1) {
      let readrestInput = new RestReadRequest();
      readrestInput.companyCode = this.companyCode;
      readrestInput.code = code;
      readrestInput.isLoadChildren = true;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Customer data...",
      });
      if (SecurityAccessManager.CustomerTransactionInquiry_IsAccessible()) {
        CustomerService.readCustomerWithChildren(
          readrestInput,
          this.readCustomerResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  readCustomerResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      this.state.customerData = customerData;
      let addressData = new AddressBean();
      let accountSummary = this.state.accountSummary;
      let accSummaryCriteria = this.state.accSummaryCriteria;
      let acc_SummaryCriteria =
        new CustomerTransactionAccountSummarySearchCriteria();
      if (response.data.customer.address != null) {
        addressData = customerData.address;
      }
      if (response.data.customer.accountSummary != null) {
        let summary = customerData.accountSummary;
        accountSummary.accountReceivableNumber =
          summary.accountReceivableNumber;
        accountSummary.accountReceivableDate = summary.accountReceivableDate;
      }
      if (accSummaryCriteria.entityType == 0) {
        let statusData = ["A", "X", "P", "F"];
        acc_SummaryCriteria.entityStatusList = statusData;
        acc_SummaryCriteria.entityType = 1013;
      } else {
        acc_SummaryCriteria.entityStatusList =
          accSummaryCriteria.entityStatusList;
        acc_SummaryCriteria.entityType = accSummaryCriteria.entityType;
      }

      this.setState({
        customerData: customerData,
        addressData: addressData,
        accountSummary: accountSummary,
        isShowModuleList: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.showOptions();
      this.fetchSingleCustomerData(customerData.code);
      this.loadCustomerCurrentAging(customerData.code);
      this.loadCustomerInvoiceDataList(acc_SummaryCriteria);
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  showOptions = () => {
    let availableList = [];
    let invBean = new BaseBean();
    invBean.code = "1013";
    invBean.description = "Invoice";
    availableList.push(invBean);
    let cmBean = new BaseBean();
    cmBean.code = "1006";
    cmBean.description = "CreditMemo";
    availableList.push(cmBean);
    this.setState({ showModuleList: availableList, isShowModuleList: true });
  };
  fetchSingleCustomerDataResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.customerTransactiontSummaryResult != null
    ) {
      const transactionSummaryResult =
        response.data.customerTransactiontSummaryResult;
      this.setState({
        transactionSummaryResult: transactionSummaryResult,
        isShowButtons: true,
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  fetchSingleCustomerData = (code) => {
    let criteria = new CustomerTransactionSummaryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.currencyCode = this.currency;
    criteria.customerCode = code;
    let pageInput = new RestPageListBean();
    let listRequest = new CustomerTransactionDataRequest();
    listRequest.criteria = criteria;
    listRequest.pageInput = pageInput;
    ReportService.getCustomerTransactionSummaryData(
      listRequest,
      this.fetchSingleCustomerDataResponse,
      this.errorCallBack
    );
  };
  showModuleOnChange = (e) => {
    let baseBean = this.state.baseBean;
    let accSummaryCriteria = this.state.accSummaryCriteria;
    let statusData = [];
    baseBean = e.target.value;
    statusData = ["A", "X", "P", "F"];
    accSummaryCriteria.entityStatusList = statusData;
    if (e.target.value == "Invoice") {
      accSummaryCriteria.entityType = 1013;
      this.setState({
        isShowInvoiceDetailsTable: true,
        isShowCreditMemoDetailsTable: false,
        baseBean: baseBean,
        accSummaryCriteria: accSummaryCriteria,
        isShowInvoiceStatus: true,
        isShowCreditMemoStatus: false,
        statusBean: new BaseBean(),
      });
    } else if (e.target.value == "CreditMemo") {
      accSummaryCriteria.entityType = 1006;
      this.setState({
        isShowCreditMemoDetailsTable: true,
        isShowInvoiceDetailsTable: false,
        baseBean: baseBean,
        accSummaryCriteria: accSummaryCriteria,
        isShowInvoiceStatus: false,
        isShowCreditMemoStatus: true,
        statusBean: new BaseBean(),
      });
    }
    this.loadCustomerInvoiceDataList(accSummaryCriteria);
  };
  showInvoiceStatusOnChange = (e) => {
    let accSummaryCriteria =
      new CustomerTransactionAccountSummarySearchCriteria();
    accSummaryCriteria.entityType = 1013;
    let statusBean = new BaseBean();
    statusBean.code = e.target.value;
    if (e.target.value === "All") {
      accSummaryCriteria.entityStatusList = ["A", "F", "X", "P"];
    } else {
      accSummaryCriteria.entityStatusList = [e.target.value];
    }
    this.state.accSummaryCriteria = accSummaryCriteria;
    this.setState({
      isShowInvoiceDetailsTable: true,
      isShowCreditMemoDetailsTable: false,
      statusBean: statusBean,
      accSummaryCriteria: accSummaryCriteria,
      customerTransactions: [],
      maBean: new MasterAttributeBean(),
    });
    setTimeout(() => {
      this.loadCustomerInvoiceDataList(accSummaryCriteria);
    }, 100);
  };
  showCreditMemoStatusOnChange = (e) => {
    let accSummaryCriteria =
      new CustomerTransactionAccountSummarySearchCriteria();
    accSummaryCriteria.entityType = 1006;
    let statusBean = new BaseBean();
    statusBean.code = e.target.value;
    if (e.target.value === "All") {
      accSummaryCriteria.entityStatusList = ["P", "F", "X"];
    } else if (e.target.value === "P") {
      accSummaryCriteria.entityStatusList = ["P", "A"];
    } else {
      accSummaryCriteria.entityStatusList = [e.target.value];
    }
    this.state.accSummaryCriteria = accSummaryCriteria;
    this.setState({
      isShowInvoiceDetailsTable: false,
      isShowCreditMemoDetailsTable: true,
      statusBean: statusBean,
      accSummaryCriteria: accSummaryCriteria,
      customerTransactions: [],
      maBean: new MasterAttributeBean(),
    });
    setTimeout(() => {
      this.loadCustomerInvoiceDataList(accSummaryCriteria);
    }, 100);
  };
  showDateOnChange = (e) => {
    let accSummaryCriteria = this.state.accSummaryCriteria;
    let baseBean = new MasterAttributeBean();
    let currentDate = new Date();
    let yesterday = new Date(currentDate);
    yesterday.setDate(yesterday.getDate() - 1);
    currentDate = currentDate.toLocaleDateString("sv-SE");
    yesterday = yesterday.toLocaleDateString("sv-SE");
    var curr = new Date();
    var firstdayofThisWeek = new Date(
      curr.setDate(curr.getDate() - curr.getDay())
    );
    var lastdayofthisweek = new Date(
      curr.setDate(curr.getDate() - curr.getDay() + 6)
    );
    firstdayofThisWeek = firstdayofThisWeek.toLocaleDateString("sv-SE");
    lastdayofthisweek = lastdayofthisweek.toLocaleDateString("sv-SE");
    var firstDayOfLastWeek = new Date(
      curr.setDate(curr.getDate() - curr.getDay() - 7)
    );
    var lastDayOfLastWeek = new Date(
      curr.setDate(curr.getDate() - curr.getDay() + 6)
    );
    firstDayOfLastWeek = firstDayOfLastWeek.toLocaleDateString("sv-SE");
    lastDayOfLastWeek = lastDayOfLastWeek.toLocaleDateString("sv-SE");
    var firstDayOfMonth = new Date(curr.getFullYear(), curr.getMonth(), 1);
    var lastDayOfMonth = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
    firstDayOfMonth = firstDayOfMonth.toLocaleDateString("sv-SE");
    lastDayOfMonth = lastDayOfMonth.toLocaleDateString("sv-SE");
    var firstDayOfWeek = new Date(curr.setDate(curr.getDate() - curr.getDay()));
    firstDayOfWeek = firstDayOfWeek.toLocaleDateString("sv-SE");
    baseBean.code = e.target.value;
    if (e.target.value === "All") {
      accSummaryCriteria.transactionDateFrom = "";
      accSummaryCriteria.transactionDateTo = "";
    } else if (e.target.value === "Today") {
      accSummaryCriteria.transactionDateFrom = currentDate;
      accSummaryCriteria.transactionDateTo = currentDate;
    } else if (e.target.value === "Yesterday") {
      accSummaryCriteria.transactionDateFrom = yesterday;
      accSummaryCriteria.transactionDateTo = yesterday;
    } else if (e.target.value === "This Week") {
      accSummaryCriteria.transactionDateFrom = firstdayofThisWeek;
      accSummaryCriteria.transactionDateTo = lastdayofthisweek;
    } else if (e.target.value === "This Month") {
      accSummaryCriteria.transactionDateFrom = firstDayOfMonth;
      accSummaryCriteria.transactionDateTo = lastDayOfMonth;
    } else if (e.target.value === "Last Week") {
      accSummaryCriteria.transactionDateFrom = firstDayOfLastWeek;
      accSummaryCriteria.transactionDateTo = lastDayOfLastWeek;
    } else if (e.target.value === "This Week-to-Date") {
      accSummaryCriteria.transactionDateFrom = firstDayOfWeek;
      accSummaryCriteria.transactionDateTo = currentDate;
    } else if (e.target.value === "This Month-to-Date") {
      accSummaryCriteria.transactionDateFrom = firstDayOfMonth;
      accSummaryCriteria.transactionDateTo = currentDate;
    }
    if (accSummaryCriteria.entityType === 1013) {
      this.setState({
        isShowInvoiceDetailsTable: true,
        isShowCreditMemoDetailsTable: false,
        maBean: baseBean,
        accSummaryCriteria: accSummaryCriteria,
        customerTransactions: [],
        statusBean: new BaseBean(),
      });
    } else if (accSummaryCriteria.entityType === 1006) {
      this.setState({
        isShowInvoiceDetailsTable: false,
        isShowCreditMemoDetailsTable: true,
        maBean: baseBean,
        accSummaryCriteria: accSummaryCriteria,
        customerTransactions: [],
        statusBean: new BaseBean(),
      });
    }
    this.loadCustomerInvoiceDataList(accSummaryCriteria);
  };
  loadCustomerCurrentAging = (code) => {
    let criteriaBean = new CustomerPaymentAgingHistoryCriteriaBean();
    criteriaBean.companyCode = this.companyCode;
    criteriaBean.customerCode = code;
    if (SecurityAccessManager.CustomerTransactionInquiry_IsAccessible()) {
      ReportService.inquireCustomerPaymentCurrentAgingHistory(
        criteriaBean,
        this.loadCustomerAgingResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerAgingResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let agingBucketList = [];
      let agingHistoryBean = new BaseCustomerPaymentAgingHistoryBean();
      if (response.data.result.agingBucketGroupBean != null) {
        if (!isEmptyArray(response.data.result.agingBucketGroupBean.buckets)) {
          agingBucketList = response.data.result.agingBucketGroupBean.buckets;
        }
        if (response.data.result.agingHistoryBean != null) {
          agingHistoryBean = response.data.result.agingHistoryBean;
        }
      }
      this.setState({
        agingBucketList: agingBucketList,
        agingHistoryBean: agingHistoryBean,
      });
    }
    this.loadUnAppliedCreditMemos();
  };
  loadUnAppliedCreditMemos = () => {
    let customerData = this.state.customerData;
    let criteria = new CustomerBalanceDetailHistoryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerCode = customerData.code;
    if (SecurityAccessManager.CustomerTransactionInquiry_IsAccessible()) {
      ReportService.inquireCustomerBalanceDetailsHistory(
        criteria,
        this.loadUnAppliedCreditMemoResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadUnAppliedCreditMemoResponse = (response) => {
    this.showErrorMessage(response.data);
    let result = new CustomerBalanceDetailHistoryInquiryResultBean();
    if (response.data != null && response.data.result != null) {
      result = response.data.result;
      let unAppliedCMs = [];
      let customerBalanceList = [];
      if (!isEmptyArray(response.data.result.creditMemoDetailsBean)) {
        unAppliedCMs = response.data.result.creditMemoDetailsBean;
      }
      if (!isEmptyArray(response.data.result.historyInfos)) {
        customerBalanceList = response.data.result.historyInfos;
      }
      this.setState({
        customerBalanceList: customerBalanceList,
        unAppliedCMs: unAppliedCMs,
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      customerBalanceData: result,
    });
  };
  customerBalanceClick = (e) => {
    if (e.detail === 1) this.setState({ isShowCustomerBalancePopup: true });
  };
  loadCustomerInvoiceDataList = (accSummaryCriteria) => {
    let acc_SummaryCriteria =
      new CustomerTransactionAccountSummarySearchCriteria();
    acc_SummaryCriteria.companyCode = this.companyCode;
    acc_SummaryCriteria.customerCode = this.state.customerData.code;
    acc_SummaryCriteria.currencyCode = this.currency;
    acc_SummaryCriteria.entityType = accSummaryCriteria.entityType;
    acc_SummaryCriteria.entityStatus = "O";
    acc_SummaryCriteria.entityStatusList = accSummaryCriteria.entityStatusList;
    acc_SummaryCriteria.transactionDateFrom =
      accSummaryCriteria.transactionDateFrom;
    acc_SummaryCriteria.transactionDateTo =
      accSummaryCriteria.transactionDateTo;
    this.setState({ accSummaryCriteria: acc_SummaryCriteria });
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 100;
    pageInput.currentPage = 1;
    let listRequest = new CustomerTransactionDataRequest();
    listRequest.criteria = acc_SummaryCriteria;
    listRequest.pageInput = pageInput;
    if (SecurityAccessManager.CustomerTransactionInquiry_IsAccessible()) {
      ReportService.getAllCustomerTransactionData(
        listRequest,
        this.loadCustomerInvoiceResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerInvoiceResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.inquiryResult != null &&
      response.data.inquiryResult.inquiryResult != null
    ) {
      let customerTransactions = [];
      if (
        !isEmptyArray(
          response.data.inquiryResult.inquiryResult.customerTransactions
        )
      ) {
        customerTransactions =
          response.data.inquiryResult.inquiryResult.customerTransactions;
      }
      this.setState({
        customerTransactions: customerTransactions,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePdfReport = (e) => {
    if (e.detail === 1) this.generateCustomerTransactionReport(1);
  };
  generateExcelReport = (e) => {
    if (e.detail === 1) this.generateCustomerTransactionReport(2);
  };
  generateCustomerTransactionReport = (reportType) => {
    let accSummaryCriteria = this.state.accSummaryCriteria;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new AllCustomerTransactionGeneralRequest();
    listRequest.criteria = accSummaryCriteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerTransactionInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateAllCustomerTransactionGeneralReport(
          listRequest,
          this.generateCustomerTransactionPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerTransactionInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateAllCustomerTransactionGeneralReport(
          listRequest,
          this.generateCustomerTransactionPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCustomerTransactionPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCustomerTransactionPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
          window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateAgingPdfReport = (e) => {
    if (e.detail === 1) {
      let customerData = this.state.customerData;
      let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.customerCode = customerData.code;
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let listRequest = new AllCustomerTransactionGeneralRequest();
      listRequest.criteria = criteria;
      listRequest.reportBean = reportBean;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating Report...",
      });
      if (reportBean.reportType == 1) {
        ReportService.generateCustomerPaymentCurrentAgingHistoryReport(
          listRequest,
          this.generateCustomerAgingPageResponse,
          this.errorCallBack
        );
      }
    }
  };
  generateCustomerAgingPageResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  unAppliedCreditMemoLinkClick = (e, val) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({ isShowUnAppliedCreditMemoPopup: true });
      } else {
        let errMsg = "NO DETAILS FOUND";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlertLvl3: true,
        });
      }
    }
  };
  viewInvoiceDetails = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({ isShowInvoiceAmountPopup: true });
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = rowData.entryEntityNumber;
        InvoiceService.readInvoice(
          readrestInput,
          this.readInvoicePageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "NO DETAILS FOUND";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readInvoicePageResponse = (response) => {
    if (response.data != null && response.data.invoice != null) {
      let readInvoiceData = response.data.invoice;
      this.setState({ readInvoiceData: readInvoiceData });
    }
  };
  viewInvoiceAppliedAmountDetails = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({ isShowInvoiceAppliedAmountPopup: true });
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = rowData.entryEntityNumber;
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readAccountReceivablePageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "NO DETAILS FOUND";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readAccountReceivablePageResponse = (response) => {
    if (
      response.data != null &&
      response.data.accountReceivablePaymentDetailPageList != null
    ) {
      let readARAppliedList = [];
      if (
        !isEmptyArray(
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails
        )
      ) {
        readARAppliedList =
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails;
        let readArList = [];
        readARAppliedList.map((list) => {
          if (list.paymentType == 1) {
            list.paymentType = "CHECK";
          } else if (list.paymentType == 2) {
            list.paymentType = "CREDIT_MEMO";
          } else if (list.paymentType == 3) {
            list.paymentType = "CREDIT_CARD";
          } else if (list.paymentType == 4) {
            list.paymentType = "DEBIT_CARD";
          } else if (list.paymentType == 5) {
            list.paymentType = "CASH";
          } else if (list.paymentType == 6) {
            list.paymentType = "CHARGE_BACK";
          } else if (list.paymentType == 8) {
            list.paymentType = "WIRE_TRANSFER";
          } else if (list.paymentType == 9) {
            list.paymentType = "ACH";
          }
          readArList.push(list);
        });
        readARAppliedList = readArList;
        this.setState({ readARAppliedList: readARAppliedList });
      }
    }
  };
  viewInvoiceAppliedCMAmountDetails = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({ isShowInvoiceAppliedCMAmountPopup: true });
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = rowData.entryEntityNumber;
        AccountReceivableService.readAccountReceivablePaymentLinesForInvoice(
          readrestInput,
          this.readAccountReceivablePageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "NO DETAILS FOUND";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  viewCreditMemoDetails = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val > 0) {
        this.setState({ isShowCreditMemoAppliedAmountPopup: true });
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = rowData.entryEntityNumber;
        AccountReceivableService.readAccountReceivablePaymentLinesForCreditMemo(
          readrestInput,
          this.readAccountReceivableCreditMemoPageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "NO DETAILS FOUND";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  readAccountReceivableCreditMemoPageResponse = (response) => {
    if (
      response.data != null &&
      response.data.accountReceivablePaymentDetailPageList != null
    ) {
      let readARCreditMemoList = [];
      if (
        !isEmptyArray(
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails
        )
      ) {
        readARCreditMemoList =
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails;
      }
      this.setState({ readARCreditMemoList: readARCreditMemoList });
    }
  };
  generateMemoPdfReport = (e) => {
    if (e.detail === 1) this.generateCreditMemoReport(1);
  };
  generateMemoExcelReport = (e) => {
    if (e.detail === 1) this.generateCreditMemoReport(2);
  };
  generateCreditMemoReport = (reportType) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let creditNumber = "";
    this.state.readARCreditMemoList.map((list) => {
      creditNumber = list.documentNumber;
    });
    let listrequest =
      new PopupCustomerTransactionCreditMemoDetailsPrintRequest();
    listrequest.companyCode = this.companyCode;
    listrequest.creditNumber = creditNumber;
    listrequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      ReportService.generatePopupCustomerTransactionCreditMemoDetailsPrintReport(
        listrequest,
        this.generateCreditMemoPageResponse,
        this.errorCallBack
      );
    } else if (reportBean.reportType == 2) {
      ReportService.generatePopupCustomerTransactionCreditMemoDetailsPrintReport(
        listrequest,
        this.generateCreditMemoPageResponseForExcel,
        this.errorCallBack
      );
    }
  };
  generateCreditMemoPageResponse = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCreditMemoPageResponseForExcel = (response) => {
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
                window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowUnAppliedCreditMemoPopup: isShowPopup,
      isShowCustomerBalancePopup: isShowPopup,
      isShowInvoiceAmountPopup: isShowPopup,
      isShowInvoiceAppliedAmountPopup: isShowPopup,
      isShowInvoiceAppliedCMAmountPopup: isShowPopup,
      isShowCreditMemoAppliedAmountPopup: isShowPopup,
      isShowMailPopup: isShowPopup,
      isShowAlert: isShowPopup,
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowARModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  clearCriteria = () => {
    let summaryCriteria = new CustomerTransactionSummaryCriteriaBean();
    summaryCriteria.companyCode = this.companyCode;
    summaryCriteria.currencyCode = this.currency;
    this.setState({ summaryCriteria: summaryCriteria });
  };
  createMail = (e) => {
    if (e.detail === 1) {
      this.setState({ isShowMailPopup: true });
      let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.customerCode = this.state.accSummaryCriteria.customerCode;
      let request = new CustomerCurrentAgingMailRequest();
      request.criteria = criteria;
      if (
        SecurityAccessManager.CustomerTransactionInquiryMailReport_IsAccessible()
      ) {
        ReportService.fetchCustomerCurrentAgingMailDefaultInfoBean(
          criteria,
          this.fetchMailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(4);
      }
    }
  };
  fetchMailResponse = (response) => {
    if (response.data != null && response.data.mailDefaultInfo != null) {
      let mailInfo = response.data.mailDefaultInfo;
      this.setState({ mailInfoBean: mailInfo });
    }
  };
  handleMailResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl3: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlertLvl3: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  sendMail = (e) => {
    if (e.detail === 1) {
      this.clearError();
      let mailInfoBean = this.state.mailInfoBean;
      let criteria = new CustomerPaymentAgingHistoryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.customerCode = this.state.accSummaryCriteria.customerCode;
      let reportBean = new RestReportBean();
      let request = new CustomerCurrentAgingMailRequest();
      request.criteria = criteria;
      request.infoBean = mailInfoBean;
      request.reportBean = reportBean;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Sending Mail...",
      });
      if (
        SecurityAccessManager.CustomerTransactionInquiryMailReport_IsAccessible()
      ) {
        ReportService.sendCustomerCurrentAgingMail(
          request,
          this.sendMailResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(4);
      }
    }
  };
  sendMailResponse = (response) => {
    this.handleMailResponse(response.data);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  convertDescription = (value, list) => {
    if (value == 1) {
      return "New Invoice";
    }
    if (value == 2) {
      return "Invoice Cancel";
    }
    if (value == 3) {
      return "Invoice Update";
    }
    if (value == 4) {
      return "Invoice Return";
    }
    if (value == 5) {
      return "Invoice Unapproval";
    }
    if (value == 6) {
      return "Credit Memo Approval, CM# " + list.documentNumber;
    }
    if (value == 7) {
      return "Credit Memo Cancel , CM# " + list.documentNumber;
    }
    if (value == 8) {
      return "Credit Memo UnApproval, CM# " + list.documentNumber;
    }
    if (value == 9) {
      return "Invoice Modify";
    }
    if (value == 11) {
      return "Check Payment , AR# " + list.documentNumber;
    }
    if (value == 12) {
      return "Credit Memo Apply, CM# " + list.documentNumber;
    }
    if (value == 13) {
      return "Credit Card Payment , AR# " + list.documentNumber;
    }
    if (value == 14) {
      return "Debit Card Payment , AR# " + list.documentNumber;
    }
    if (value == 15) {
      return "Cash Payment , AR# " + list.documentNumber;
    }
    if (value == 16) {
      return "Charge back Apply , AR# " + list.documentNumber;
    }
  };
  convertAmount = (value, listValue) => {
    let returnvalue = value;
    if (listValue == 1) {
      return this.color("[" + returnvalue + "]", listValue);
    }
    if (listValue == 2) {
      return this.color(returnvalue, listValue);
    }
  };
  color = (value, listvalue) => {
    if (listvalue == 1) {
      return <div class="purple">{value}</div>;
    }
    if (listvalue == 2) {
      return <div class="blue">{value}</div>;
    }
  };
  mailOnChange = (e) => {
    let mailInfoBean = this.state.mailInfoBean;
    mailInfoBean[e.target.name] = e.target.value;
    this.setState({ mailInfoBean: mailInfoBean });
  };
  currencyOnChange = (e) => {
    let summaryCriteria = this.state.summaryCriteria;
    summaryCriteria[e.target.name] = e.target.value;
    this.currency = e.target.value;
    this.setState({ summaryCriteria: summaryCriteria });
  };
  docConvertor = (data, rowData) => {
    let doc = data;
    if (
      rowData.paymentType == "CREDIT_CARD" ||
      rowData.paymentType == "DEBIT_CARD"
    ) {
      let hideNum = [];
      for (let i = 0; i < doc.length; i++) {
        if (i < doc.length - 4) {
          hideNum.push("*");
        } else {
          hideNum.push(doc[i]);
        }
      }
      let str = hideNum.join("");
      // let str = doc.replace(/\d(?=\d{4})/g, "*");
      doc = str;
    }
    return doc;
  };
  appAmtStatusConvertor = (value) => {
    if (value) {
      return "Posted";
    } else {
      return "Non-Posted";
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  handleSortingReadARAppliedChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingReadARApplied(sortField, sortOrder);
    }
  };
  handleSortingReadARApplied = (sortField, sortOrder) => {
    let list = this.state.readARAppliedList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ readARAppliedList: sorted });
    }
  };
  handleSortingReadARCreditMemoChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingReadARCreditMemo(sortField, sortOrder);
    }
  };
  handleSortingReadARCreditMemo = (sortField, sortOrder) => {
    let list = this.state.readARCreditMemoList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ readARCreditMemoList: sorted });
    }
  };
  handleSortingUnAppliedCMChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingUnAppliedCM(sortField, sortOrder);
    }
  };
  handleSortingUnAppliedCM = (sortField, sortOrder) => {
    let list = this.state.unAppliedCMs;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ unAppliedCMs: sorted });
    }
  };
  handleSortingCustomerTransactionChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerTransaction(sortField, sortOrder);
    }
  };
  handleSortingCustomerTransaction = (sortField, sortOrder) => {
    let list = this.state.customerTransactions;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerTransactions: sorted });
    }
  };
  handleSortingCustomerBalanceChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerBalance(sortField, sortOrder);
    }
  };
  handleSortingCustomerBalance = (sortField, sortOrder) => {
    let list = this.state.customerBalanceList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerBalanceList: sorted });
    }
  };
  customerColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2")
        .setClickDetails(true, false, this.viewCustomerDetails, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalDue", "closingBalanceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("LastPaidDate", "accountReceivableDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );

    return columns;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let summaryCriteria = this.state.summaryCriteria;
    let customerData = this.state.customerData;
    let addressData = this.state.addressData;
    let accountSummary = this.state.accountSummary;
    let agingBucketList = this.state.agingBucketList;
    let agingHistoryBean = this.state.agingHistoryBean;
    let baseBean = this.state.baseBean;
    let customerBalanceData = this.state.customerBalanceData;
    let readInvoiceData = this.state.readInvoiceData;
    let maBean = this.state.maBean;
    let statusBean = this.state.statusBean;
    let transactionSummaryResult = this.state.transactionSummaryResult;
    let isShowButtons = this.state.isShowButtons;
    let totalDue = 0;
    if (!isEmpty(readInvoiceData))
      if (
        !isEmpty(readInvoiceData.grandTotalAmount) &&
        !isEmpty(readInvoiceData.netPaidAmount)
      )
        totalDue =
          readInvoiceData.grandTotalAmount - readInvoiceData.netPaidAmount;
    let currencyCode1 = summaryCriteria.currencyCode;
    let currencyCode2 = summaryCriteria.currencyCode;
    let currencyCode3 = summaryCriteria.currencyCode;
    let currencyCode4 = summaryCriteria.currencyCode;
    let currencyCode5 = summaryCriteria.currencyCode;
    let currencyCode6 = summaryCriteria.currencyCode;
    let currencyCode7 = summaryCriteria.currencyCode;
    let currencyCode8 = summaryCriteria.currencyCode;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.moduleExit}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowExitButton={this.state.isShowExitButton}
          clearError={this.clearError}
        />
        {this.state.isInquiryDatasFound && (
          <div className="">
            <div className="div_inline">
              <div className="div_30_no_overflow">
                <div className="header_div">
                  <Row>
                    <Col sm="4">
                      <FormLabel>Customers - Curency</FormLabel>
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        name="currencyCode"
                        value={summaryCriteria.currencyCode}
                        className="summary_text_box1"
                        lookupRequired={true}
                        lookupHandler={this.state.currencyLookupHandler}
                        onChange={this.currencyOnChange}
                      />
                    </Col>
                    <Col sm="2">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetCustomers(e)}
                      >
                        ShowAll Customer
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="5">
                      {" "}
                      <FormLabel>CustomerCodeContaining</FormLabel>
                    </Col>
                    <Col sm="7">
                      <InputTextbox
                        type="text"
                        name="customerCodeContains"
                        onChange={this.summaryOnChange}
                        value={summaryCriteria.customerCodeContains}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="5">
                      {" "}
                      <FormLabel>CustomerNameContaining</FormLabel>
                    </Col>
                    <Col sm="7">
                      <InputTextbox
                        name="customerNameContains"
                        value={summaryCriteria.customerNameContains}
                        onChange={this.summaryOnChange}
                      />
                    </Col>
                  </Row>
                  <Row className="d-flex justify-content-center">
                    <Col sm="3">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.searchCustomers(e)}
                      >
                        {" "}
                        Search
                      </Button>
                    </Col>
                    <Col sm="3">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetCustomers(e)}
                      >
                        Reset
                      </Button>
                    </Col>
                  </Row>
                </div>
                <div className="div_Custom_2">
                  <CustomTable
                    data={inquiryDataList}
                    columns={this.customerColumns()}
                    label={"CustomerList"}
                  />
                </div>
                {/* <div className="div_Custom_8">
                  
                  <Table id="fabrics_tables">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "customerCode")
                          }
                        >
                          Customer
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "customerName")
                          }
                        >
                          Name
                          {this.state.order === "desc" &&
                          this.state.sortField === "customerName" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "closingBalanceAmount")
                          }
                          className="max-wt-6"
                        >
                          TotalDue
                          {this.state.order === "desc" &&
                          this.state.sortField === "closingBalanceAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "accountReceivableDate")
                          }
                        >
                          LastPaidDate
                          {this.state.order === "desc" &&
                          this.state.sortField === "accountReceivableDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {inquiryDataList.map((inquiryInfo, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewCustomerDetails(
                                  e,
                                  inquiryInfo.customerCode
                                )
                              }
                            >
                              {inquiryInfo.customerCode}
                            </Button>
                          </td>
                          <td>{inquiryInfo.customerName}</td>
                          <td className="text-end">
                            {toCommaSeperatedAmount(
                              inquiryInfo.closingBalanceAmount
                            )}
                          </td>
                          <td>{inquiryInfo.accountReceivableDate}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {inquiryDataList.length != 0 ? null : (
                    <div className="no_Data_small">{"NO DATA"}</div>
                  )}
                </div> */}
              </div>
              <div className="div_70_no_overflow">
                <div className="div_inline">
                  <div className="div_60_no_overflow">
                    <div className="div_inline header_div">
                      <div className="div_Equal_no_height div_Custom_7">
                        <Row>
                          <FormLabel>
                            <span>
                              Customer Information - {customerData.code} ::{" "}
                              {customerData.description}
                            </span>
                          </FormLabel>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormLabel>CustType :</FormLabel>
                          </Col>
                          <Col sm="6">
                            <FormLabel className="">
                              {customerData.customerTypeCode}
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormLabel>Company :</FormLabel>
                          </Col>{" "}
                          <Col sm="6">
                            <FormLabel>
                              {customerData.customerCompanyName}
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            <FormLabel>Phone :</FormLabel>
                          </Col>
                          <Col sm="7">
                            <FormLabel>{addressData.phone1}</FormLabel>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm="4">
                            <FormLabel>Alt Phone :</FormLabel>
                          </Col>{" "}
                          <Col sm="8">
                            <FormLabel>{addressData.phone2}</FormLabel>
                          </Col>
                        </Row> */}
                        <Row>
                          <Col sm="5">
                            <FormLabel>Contact :</FormLabel>
                          </Col>{" "}
                          <Col sm="7">
                            <FormLabel>{addressData.contactPerson}</FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            <FormLabel>Fax :</FormLabel>
                          </Col>{" "}
                          <Col sm="7">
                            <FormLabel>{addressData.fax}</FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            <FormLabel>Email :</FormLabel>
                          </Col>{" "}
                          <Col sm="7">
                            <FormLabel>{addressData.email}</FormLabel>
                          </Col>
                        </Row>
                        {/* <Row>
                          <Col sm="4">
                            <FormLabel>Billing Add :</FormLabel>
                          </Col>{" "}
                          <Col sm="8">
                            <FormLabel></FormLabel>
                          </Col>
                        </Row> */}
                      </div>
                      <div className="div_Equal_no_height">
                        <Row>
                          <FormLabel>Last Payment Details</FormLabel>
                        </Row>
                        <Row>
                          <Col sm="5">
                            <FormLabel>TotalDue</FormLabel>
                          </Col>
                          <Col sm="7">
                            <NumberFormatInputbox
                              value={transactionSummaryResult.totalDueAmount}
                              className="summary_text_box1 text-right"
                              disabled={true}
                              decimalScale={2}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            {" "}
                            <FormLabel
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewARModule(
                                  e,
                                  accountSummary.accountReceivableNumber
                                )
                              }
                            >
                              LastAR#
                            </FormLabel>
                          </Col>
                          <Col sm="7">
                            <InputTextbox
                              value={accountSummary.accountReceivableNumber}
                              className="summary_text_box1"
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            {" "}
                            <FormLabel>LastPaidDate</FormLabel>
                          </Col>
                          <Col sm="7">
                            <InputTextbox
                              value={transactionSummaryResult.lastPaidDate}
                              className="summary_text_box1 "
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            {" "}
                            <FormLabel className="word-Break">
                              LastPaidAmt
                            </FormLabel>
                          </Col>
                          <Col sm="7">
                            <NumberFormatInputbox
                              value={transactionSummaryResult.lastPaidAmount}
                              className="summary_text_box1 text-right"
                              decimalScale={2}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="5">
                            {" "}
                            <FormLabel
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.unAppliedCreditMemoLinkClick(
                                  e,
                                  transactionSummaryResult.totalUnAppliedCreditAmount
                                )
                              }
                            >
                              UnApplied CreditMemo
                            </FormLabel>
                          </Col>
                          <Col sm="7">
                            <NumberFormatInputbox
                              value={
                                transactionSummaryResult.totalUnAppliedCreditAmount
                              }
                              className="summary_text_box1 text-right"
                              decimalScale={2}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row className="d-flex justify-content-center">
                          {isShowButtons && (
                            <Col>
                              <Button
                                size="sm"
                                id="fabric_Add_Button"
                                onClick={(e) => this.customerBalanceClick(e)}
                              >
                                Customer Balance
                              </Button>
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                  <div className="div_40_no_overflow">
                    <Row>
                      <Col>
                        <FormLabel>Customer Aging Details</FormLabel>
                      </Col>
                    </Row>
                    <div className="table_small">
                      {!isEmptyArray(agingBucketList) && (
                        <Table id="fabrics_tables">
                          <thead>
                            {agingBucketList.map((list, index) => (
                              <th>{list.code}</th>
                            ))}
                          </thead>
                          <tbody>
                            {agingHistoryBean != null && (
                              <tr>
                                <td>
                                  {agingHistoryBean.standardCurrentAgeAmount}
                                </td>
                                <td>{agingHistoryBean.ageAmount1}</td>
                                <td>{agingHistoryBean.ageAmount2}</td>
                                <td>{agingHistoryBean.ageAmount3}</td>
                                <td>{agingHistoryBean.ageAmount4}</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      )}
                      {isEmptyArray(agingBucketList) && (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                    <Row>
                      <Col>
                        <FormLabel>UnApplied CM Details</FormLabel>
                      </Col>
                    </Row>
                    <div className="table_small">
                      <Table id="fabrics_tables">
                        <thead>
                          <tr>
                            <th
                              onClick={(e) =>
                                this.handleSortingUnAppliedCMChange(
                                  e,
                                  "creditMemoDate"
                                )
                              }
                            >
                              Date
                              {this.state.order === "desc" &&
                              this.state.sortField === "creditMemoDate" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingUnAppliedCMChange(
                                  e,
                                  "creditMemoCode"
                                )
                              }
                            >
                              CM#
                              {this.state.order === "desc" &&
                              this.state.sortField === "creditMemoCode" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingUnAppliedCMChange(
                                  e,
                                  "totalCreditAmount"
                                )
                              }
                            >
                              TotalAmt
                              {this.state.order === "desc" &&
                              this.state.sortField === "totalCreditAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingUnAppliedCMChange(
                                  e,
                                  "appliedCreditMemoAmount"
                                )
                              }
                            >
                              AppliedAmt
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "appliedCreditMemoAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingUnAppliedCMChange(
                                  e,
                                  "unAppliedCreditMemoAmount"
                                )
                              }
                            >
                              UnAppliedAmt
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "unAppliedCreditMemoAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                          </tr>
                        </thead>
                        {this.state.unAppliedCMs != null && (
                          <tbody>
                            {this.state.unAppliedCMs.map((list, index) => (
                              <tr key={index}>
                                <td>{list.creditMemoDate}</td>
                                <td>
                                  <Button
                                    size="sm"
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.viewCreditMemoModule(
                                        e,
                                        list.creditMemoCode
                                      )
                                    }
                                  >
                                    {list.creditMemoCode}
                                  </Button>
                                </td>
                                <td className="text-right">
                                  {toCommaSeperatedAmount(
                                    list.totalCreditAmount
                                  )}
                                </td>
                                <td className="text-right">
                                  {toCommaSeperatedAmount(
                                    list.appliedCreditMemoAmount
                                  )}
                                </td>
                                <td className="text-right">
                                  {toCommaSeperatedAmount(
                                    list.unAppliedCreditMemoAmount
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>
                      {this.state.unAppliedCMs.length != 0 ? null : (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="">
                  <div>
                    {" "}
                    <Row>
                      <Col sm="1">Show</Col>
                      <Col sm="2">
                        {this.state.isShowModuleList == true && (
                          <FormControl
                            as="select"
                            custom
                            onChange={this.showModuleOnChange}
                            name="description"
                            value={baseBean.description}
                          >
                            {this.state.showModuleList.map((list, index) => (
                              <option key={index} value={list.description}>
                                {list.description}
                              </option>
                            ))}
                          </FormControl>
                        )}
                        {this.state.isShowModuleList == false && (
                          <FormControl
                            as="select"
                            custom
                            name="description"
                            value={baseBean.description}
                            disabled={true}
                          >
                            <option value={0}></option>
                          </FormControl>
                        )}
                      </Col>
                      <Col sm="1">Filter</Col>
                      <Col sm="2">
                        {this.state.isShowModuleList == true &&
                          this.state.isShowInvoiceStatus && (
                            <FormControl
                              as="select"
                              custom
                              onChange={this.showInvoiceStatusOnChange}
                              name="code"
                              value={statusBean.code}
                            >
                              <option value="All">All</option>
                              <option value="A">UnPaid</option>
                              <option value="F">Paid</option>
                              <option value="X">Cancelled</option>
                            </FormControl>
                          )}
                        {this.state.isShowModuleList == true &&
                          this.state.isShowCreditMemoStatus && (
                            <FormControl
                              as="select"
                              custom
                              onChange={this.showCreditMemoStatusOnChange}
                              name="code"
                              value={statusBean.code}
                            >
                              <option value="All">All</option>
                              <option value="P">Open</option>
                              <option value="X">Cancelled</option>
                              <option value="F">Closed</option>
                            </FormControl>
                          )}
                        {this.state.isShowModuleList == false && (
                          <FormControl
                            as="select"
                            custom
                            name="description"
                            value={baseBean.description}
                            disabled={true}
                          >
                            <option value={0}></option>
                          </FormControl>
                        )}
                      </Col>
                      <Col sm="1">Date</Col>
                      <Col sm="2">
                        {this.state.isShowModuleList == true && (
                          <FormControl
                            as="select"
                            custom
                            onChange={this.showDateOnChange}
                            name="code"
                            value={maBean.code}
                          >
                            <option value="All">All</option>
                            <option value="Today">Today</option>
                            <option value="This Week">This Week</option>
                            <option value="This Week-to-Date">
                              This Week-to-Date
                            </option>
                            <option value="This Month">This Month</option>
                            <option value="This Month-to-Date">
                              This Month-to-Date
                            </option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Last Week">Last Week</option>
                          </FormControl>
                        )}
                        {this.state.isShowModuleList == false && (
                          <FormControl
                            as="select"
                            custom
                            name="description"
                            value={baseBean.description}
                            disabled={true}
                          >
                            <option value={0}></option>
                          </FormControl>
                        )}
                      </Col>
                      {isShowButtons && (
                        <Col sm="1">
                          <Button size="sm" id="fabric_Add_Button">
                            Exec
                          </Button>
                        </Col>
                      )}
                      {isShowButtons && (
                        <Col sm="1">
                          <Button
                            size="sm"
                            id="fabric_Add_Button"
                            onClick={(e) => this.generatePdfReport(e)}
                          >
                            Pdf
                          </Button>
                        </Col>
                      )}
                      {isShowButtons && (
                        <Col sm="1">
                          <Button
                            size="sm"
                            id="fabric_Add_Button"
                            onClick={(e) => this.generateExcelReport(e)}
                          >
                            Excel
                          </Button>
                        </Col>
                      )}
                      {isShowButtons && (
                        <Col sm="2">
                          <Button
                            size="sm"
                            id="fabric_Add_Button"
                            onClick={(e) => this.generateAgingPdfReport(e)}
                          >
                            AgingPdf
                          </Button>
                        </Col>
                      )}
                      {isShowButtons && (
                        <Col sm="2">
                          <Button
                            size="sm"
                            id="fabric_Add_Button"
                            onClick={(e) => this.createMail(e)}
                          >
                            AgingMail
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </div>
                  {this.state.isShowInvoiceDetailsTable && (
                    <div className="div_default">
                      <Table id="fabrics_tables">
                        <thead>
                          <tr>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "entryEntityNumber"
                                )
                              }
                            >
                              Document
                              {this.state.order === "desc" &&
                              this.state.sortField === "entryEntityNumber" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "transactionDate"
                                )
                              }
                            >
                              Date
                              {this.state.order === "desc" &&
                              this.state.sortField === "transactionDate" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "invoiceAmount"
                                )
                              }
                            >
                              Amount
                              {this.state.order === "desc" &&
                              this.state.sortField === "invoiceAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "openAmount"
                                )
                              }
                            >
                              AmountDue
                              {this.state.order === "desc" &&
                              this.state.sortField === "openAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "generalPaidAmount"
                                )
                              }
                            >
                              AppliedAmt
                              {this.state.order === "desc" &&
                              this.state.sortField === "generalPaidAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "creditPaidAmount"
                                )
                              }
                            >
                              AppliedCM
                              {this.state.order === "desc" &&
                              this.state.sortField === "creditPaidAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "adjustedPaidAmount"
                                )
                              }
                            >
                              PaidAdjustedAmt
                              {this.state.order === "desc" &&
                              this.state.sortField === "adjustedPaidAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "customerPurchaseOrderNumber"
                                )
                              }
                            >
                              PO#
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "customerPurchaseOrderNumber" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "paymentDueDate"
                                )
                              }
                            >
                              DueDate
                              {this.state.order === "desc" &&
                              this.state.sortField === "paymentDueDate" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "entityStatus"
                                )
                              }
                            >
                              Status
                              {this.state.order === "desc" &&
                              this.state.sortField === "entityStatus" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                          </tr>
                        </thead>
                        {this.state.customerTransactions != null && (
                          <tbody>
                            {this.state.customerTransactions.map(
                              (inv, index) => (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceModule(
                                          e,
                                          inv.entryEntityNumber
                                        )
                                      }
                                    >
                                      {inv.entryEntityNumber}
                                    </Button>
                                  </td>
                                  <td>{inv.transactionDate}</td>
                                  <td className="text-end">
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceDetails(
                                          e,
                                          inv.invoiceAmount,
                                          inv
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        inv.invoiceAmount
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-end">
                                    {toCommaSeperatedAmount(inv.openAmount)}
                                  </td>
                                  <td className="text-end">
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceAppliedAmountDetails(
                                          e,
                                          inv.generalPaidAmount,
                                          inv
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        inv.generalPaidAmount
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-end">
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewInvoiceAppliedCMAmountDetails(
                                          e,
                                          inv.creditPaidAmount,
                                          inv
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        inv.creditPaidAmount
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-end">
                                    {toCommaSeperatedAmount(
                                      inv.adjustedPaidAmount
                                    )}
                                  </td>
                                  <td>{inv.customerPurchaseOrderNumber}</td>
                                  <td>{inv.paymentDueDate}</td>
                                  <td>
                                    {this.statusConventor(inv.entityStatus, 1)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        )}
                      </Table>
                    </div>
                  )}
                  {this.state.isShowCreditMemoDetailsTable && (
                    <div className="div_default">
                      <Table id="fabrics_tables">
                        <thead>
                          <tr>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "entryEntityNumber"
                                )
                              }
                            >
                              Document
                              {this.state.order === "desc" &&
                              this.state.sortField === "entryEntityNumber" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "transactionDate"
                                )
                              }
                            >
                              Date
                              {this.state.order === "desc" &&
                              this.state.sortField === "transactionDate" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "creditMemoAmount"
                                )
                              }
                            >
                              Amount
                              {this.state.order === "desc" &&
                              this.state.sortField === "creditMemoAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "creditMemoAppliedAmount"
                                )
                              }
                            >
                              AppliedAmt
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "creditMemoAppliedAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "openAmount"
                                )
                              }
                            >
                              UnAppliedAmount
                              {this.state.order === "desc" &&
                              this.state.sortField === "openAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingCustomerTransactionChange(
                                  e,
                                  "entityStatus"
                                )
                              }
                            >
                              Status
                              {this.state.order === "desc" &&
                              this.state.sortField === "entityStatus" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                          </tr>
                        </thead>
                        {this.state.customerTransactions != null && (
                          <tbody>
                            {this.state.customerTransactions.map(
                              (inv, index) => (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewCreditMemoModule(
                                          e,
                                          inv.entryEntityNumber
                                        )
                                      }
                                    >
                                      {inv.entryEntityNumber}
                                    </Button>
                                  </td>
                                  <td>{inv.transactionDate}</td>
                                  <td className="text-right">
                                    {toCommaSeperatedAmount(
                                      inv.creditMemoAmount
                                    )}
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      size="sm"
                                      variant="secondry"
                                      className="hyperLinkText"
                                      onClick={(e) =>
                                        this.viewCreditMemoDetails(
                                          e,
                                          inv.creditMemoAppliedAmount,
                                          inv
                                        )
                                      }
                                    >
                                      {inv.creditMemoAppliedAmount}
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    {toCommaSeperatedAmount(inv.openAmount)}
                                  </td>
                                  <td>
                                    {this.statusConventor(inv.entityStatus, 2)}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        )}
                      </Table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowMailPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel3"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Mail Customer Current Aging"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.sendMail(e)}
              >
                Send
              </Button>
            </div>
          }
          content={
            <GenerateMailPopup
              {...this.state}
              mailOnChange={this.mailOnChange}
            />
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerBalancePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Customer Balance"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox value={this.companyCode} disabled={true} />{" "}
                  </Col>

                  <Col sm="1">
                    <FormLabel>CustomerName</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={customerData.description}
                      disabled={true}
                    />{" "}
                  </Col>
                  {/* <Col sm="1">
                    <FormLabel>HistoryDateFrom</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={customerBalanceData.historyDateFrom}
                      disabled={true}
                    />{" "}
                  </Col>

                  <Col sm="1">
                    <FormLabel>HistoryDateTo</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={customerBalanceData.historyDateFrom}
                      disabled={true}
                    />{" "}
                  </Col> */}
                </Row>
                <Row>
                  <Col sm="1">
                    {" "}
                    <FormLabel>OpeningBalance</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="2">
                    <InputTextbox
                      value={customerBalanceData.openingBalance}
                      className="summary_input text-right"
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>ClosingBalance</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      className="summary_input text-right"
                      value={customerBalanceData.closingBalance}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="1">
                    <FormLabel
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.unAppliedCreditMemoLinkClick(
                          e,
                          agingHistoryBean.totalUnAppliedCreditMemoAmount
                        )
                      }
                    >
                      UnApplied CreditMemo
                    </FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={customerBalanceData.totalUnAppliedCreditMemoAmount}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="1">
                    <FormLabel>CurrencyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      className="summary_input text-right"
                      value={customerBalanceData.currency}
                      disabled={true}
                    />{" "}
                  </Col>
                </Row>
                <div className="div_default">
                  <Table id="fabrics_tables">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "historyDate"
                            )
                          }
                        >
                          Date
                          {this.state.order === "desc" &&
                          this.state.sortField === "historyDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "openingBalanceAmount"
                            )
                          }
                        >
                          OpeningBalance
                          {this.state.order === "desc" &&
                          this.state.sortField === "openingBalanceAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "transactionType"
                            )
                          }
                        >
                          Description
                          {this.state.order === "desc" &&
                          this.state.sortField === "transactionType" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "invoiceNumber"
                            )
                          }
                        >
                          Invoice
                          {this.state.order === "desc" &&
                          this.state.sortField === "invoiceNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "transactionAmount"
                            )
                          }
                        >
                          Amount
                          {this.state.order === "desc" &&
                          this.state.sortField === "transactionAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "closingBalanceAmount"
                            )
                          }
                        >
                          ClosingBalance
                          {this.state.order === "desc" &&
                          this.state.sortField === "closingBalanceAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingCustomerBalanceChange(
                              e,
                              "remarks"
                            )
                          }
                        >
                          Remarks
                          {this.state.order === "desc" &&
                          this.state.sortField === "remarks" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.customerBalanceList.map((list, index) => (
                        <tr key={index}>
                          <td>{list.historyDate}</td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(list.openingBalanceAmount)}
                          </td>
                          <td>
                            {this.convertDescription(
                              list.transactionType,
                              list
                            )}
                          </td>
                          <td>
                            <Button
                              className="hyperLinkText"
                              variant="secondry"
                              onClick={(e) =>
                                this.viewInvoiceModule(e, list.invoiceNumber)
                              }
                            >
                              {list.invoiceNumber}
                            </Button>
                          </td>
                          <td className="text-right">
                            {this.convertAmount(
                              list.transactionAmount,
                              list.accountUpdateType
                            )}
                          </td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(list.closingBalanceAmount)}
                          </td>
                          <td>{list.remarks}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {this.state.customerBalanceList.length != 0 ? null : (
                    <div className="no_Data">{"NO DATA"}</div>
                  )}
                </div>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowUnAppliedCreditMemoPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"UnApplied Credit Memo Details"}
          popupLvlClass={"popupSizeLevel3"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="div_default">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingUnAppliedCMChange(e, "creditMemoDate")
                      }
                    >
                      Date
                      {this.state.order === "desc" &&
                      this.state.sortField === "creditMemoDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingUnAppliedCMChange(e, "creditMemoCode")
                      }
                    >
                      CM#
                      {this.state.order === "desc" &&
                      this.state.sortField === "creditMemoCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingUnAppliedCMChange(
                          e,
                          "totalCreditAmount"
                        )
                      }
                    >
                      TotalAmt
                      {this.state.order === "desc" &&
                      this.state.sortField === "totalCreditAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingUnAppliedCMChange(
                          e,
                          "appliedCreditMemoAmount"
                        )
                      }
                    >
                      AppliedAmt
                      {this.state.order === "desc" &&
                      this.state.sortField === "appliedCreditMemoAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingUnAppliedCMChange(
                          e,
                          "unAppliedCreditMemoAmount"
                        )
                      }
                    >
                      UnAppliedAmt
                      {this.state.order === "desc" &&
                      this.state.sortField === "unAppliedCreditMemoAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {this.state.unAppliedCMs != null && (
                  <tbody>
                    {this.state.unAppliedCMs.map((list, index) => (
                      <tr key={index}>
                        <td>{list.creditMemoDate}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCreditMemoModule(e, list.creditMemoCode)
                            }
                          >
                            {list.creditMemoCode}
                          </Button>
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(list.totalCreditAmount)}
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(list.appliedCreditMemoAmount)}
                        </td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(
                            list.unAppliedCreditMemoAmount
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </Table>
              {this.state.unAppliedCMs != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Amount Details"}
          popupLvlClass={"popupSizeLevel5"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              {this.state.readInvoiceData != null && (
                <div>
                  <Row>
                    <FormLabel> Amount Details</FormLabel>
                  </Row>
                  <Row>
                    <Col>
                      {" "}
                      <FormLabel>SubTotal</FormLabel>
                    </Col>
                    <Col className="summary_text_box">
                      <NumberFormatInputbox
                        value={readInvoiceData.subTotalAmount}
                        className="summary_input text-right"
                        disabled={true}
                        decimalScale={2}
                      />
                    </Col>
                    <Col>
                      <InputTextbox
                        className="summary_input text-right"
                        disabled={true}
                        value={currencyCode1}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>TaxAmount</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={readInvoiceData.totalTaxAmount}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox disabled={true} value={currencyCode2} />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>DiscountAmount</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={readInvoiceData.discountAmount}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox disabled={true} value={currencyCode3} />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>ExtraCharges</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={readInvoiceData.extraChargesAmount}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox disabled={true} value={currencyCode4} />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>GrandTotal</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={readInvoiceData.grandTotalAmount}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox
                        className="summary_input text-right"
                        disabled={true}
                        value={currencyCode5}
                      />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>TotalPaid</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={readInvoiceData.paidAmount}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox disabled={true} value={currencyCode6} />{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormLabel>TotalDue</FormLabel>
                    </Col>
                    <Col>
                      <NumberFormatInputbox
                        className="summary_input text-right"
                        value={totalDue}
                        disabled={true}
                        decimalScale={2}
                      />{" "}
                    </Col>
                    <Col>
                      <InputTextbox disabled={true} value={currencyCode7} />{" "}
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Applied Amount Details"}
          popupLvlClass={"popupSizeLevel3"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "accountReceivableNumber"
                          )
                        }
                      >
                        AR#
                        {this.state.order === "desc" &&
                        this.state.sortField === "accountReceivableNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentPostDate"
                          )
                        }
                      >
                        Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentPostDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentType"
                          )
                        }
                      >
                        Type
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentType" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "documentNumber"
                          )
                        }
                      >
                        Document#
                        {this.state.order === "desc" &&
                        this.state.sortField === "documentNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentAmount"
                          )
                        }
                      >
                        AppliedAmount
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "currencyCode"
                          )
                        }
                      >
                        Currency
                        {this.state.order === "desc" &&
                        this.state.sortField === "currencyCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(e, "applied")
                        }
                      >
                        Status
                        {this.state.order === "desc" &&
                        this.state.sortField === "applied" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {this.state.readARAppliedList != null && (
                    <tbody>
                      {this.state.readARAppliedList
                        .filter(
                          (li) =>
                            li.paymentType != "CREDIT_MEMO" &&
                            li.paymentType != "CHARGE_BACK"
                        )
                        .map((list, index) => (
                          <tr key={index}>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewARModule(
                                    e,
                                    list.accountReceivableNumber
                                  )
                                }
                              >
                                {list.accountReceivableNumber}
                              </Button>
                            </td>
                            <td>{list.paymentPostDate}</td>
                            <td>{list.paymentType}</td>
                            <td>
                              {this.docConvertor(list.documentNumber, list)}
                            </td>
                            <td className="text-right">
                              {toCommaSeperatedAmount(list.paymentAmount)}
                            </td>
                            <td>{list.currencyCode}</td>
                            <td>{this.appAmtStatusConvertor(list.applied)}</td>
                          </tr>
                        ))}
                    </tbody>
                  )}
                </Table>
                {this.state.readARAppliedList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowInvoiceAppliedCMAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Applied Amount Details"}
          popupLvlClass={"popupSizeLevel3"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "accountReceivableNumber"
                          )
                        }
                      >
                        AR#
                        {this.state.order === "desc" &&
                        this.state.sortField === "accountReceivableNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentPostDate"
                          )
                        }
                      >
                        Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentPostDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentType"
                          )
                        }
                      >
                        Type
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentType" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "documentNumber"
                          )
                        }
                      >
                        Document#
                        {this.state.order === "desc" &&
                        this.state.sortField === "documentNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "paymentAmount"
                          )
                        }
                      >
                        AppliedAmount
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARAppliedChange(
                            e,
                            "currencyCode"
                          )
                        }
                      >
                        Currency
                        {this.state.order === "desc" &&
                        this.state.sortField === "currencyCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  {this.state.readARAppliedList != null && (
                    <tbody>
                      {this.state.readARAppliedList
                        .filter((li) => li.paymentType == "CREDIT_MEMO")
                        .map((list, index) => (
                          <tr key={index}>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewARModule(
                                    e,
                                    list.accountReceivableNumber
                                  )
                                }
                              >
                                {list.accountReceivableNumber}
                              </Button>
                            </td>
                            <td>{list.paymentPostDate}</td>
                            <td>{list.paymentType}</td>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewCreditMemoModule(
                                    e,
                                    list.documentNumber
                                  )
                                }
                              >
                                {list.documentNumber}
                              </Button>
                            </td>
                            <td className="text-right">
                              {toCommaSeperatedAmount(list.paymentAmount)}
                            </td>
                            <td>{list.currencyCode}</td>
                            <td>Posted</td>
                          </tr>
                        ))}
                    </tbody>
                  )}
                </Table>
                {this.state.readARAppliedList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCreditMemoAppliedAmountPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          popupLvlClass={"popupSizeLevel0"}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateMemoPdfReport(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateMemoExcelReport(e)}
              >
                EXCEL
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <FormLabel> Details </FormLabel>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARCreditMemoChange(
                            e,
                            "invoiceNumber"
                          )
                        }
                      >
                        Invoice#
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARCreditMemoChange(
                            e,
                            "accountReceivableNumber"
                          )
                        }
                      >
                        AR#
                        {this.state.order === "desc" &&
                        this.state.sortField === "accountReceivableNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARCreditMemoChange(
                            e,
                            "paymentAmount"
                          )
                        }
                      >
                        PaidAmount
                        {this.state.order === "desc" &&
                        this.state.sortField === "paymentAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingReadARCreditMemoChange(
                            e,
                            "currencyCode"
                          )
                        }
                      >
                        Currency
                        {this.state.order === "desc" &&
                        this.state.sortField === "currencyCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {this.state.readARCreditMemoList != null && (
                    <tbody>
                      {this.state.readARCreditMemoList.map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewInvoiceModule(e, list.invoiceNumber)
                              }
                            >
                              {list.invoiceNumber}
                            </Button>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewARModule(
                                  e,
                                  list.accountReceivableNumber
                                )
                              }
                            >
                              {list.accountReceivableNumber}
                            </Button>
                          </td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(list.paymentAmount)}
                          </td>
                          <td>{list.currencyCode}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {this.state.readARCreditMemoList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

class GenerateMailPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  mailOnChange = (e) => {
    this.props.mailOnChange(e);
  };
  render() {
    let mailInfoBean = this.props.mailInfoBean;
    const textAreaStyle = {
      height: "25em",
      width: "80em",
      resize: "none",
      padding: "10px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    return (
      <div className="">
        <Row></Row>
        <Row>
          <Col sm="2">
            <FormLabel>From</FormLabel>
          </Col>
          <Col sm="8">
            <InputTextbox value={mailInfoBean.from} disabled={true} />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>To</FormLabel>
          </Col>
          <Col sm="8">
            <InputTextbox
              name="tos"
              value={mailInfoBean.tos}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Cc's</FormLabel>
          </Col>
          <Col sm="8">
            <InputTextbox
              name="ccs"
              value={mailInfoBean.ccs}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Bc's</FormLabel>
          </Col>
          <Col sm="8">
            <InputTextbox
              name="bccs"
              value={mailInfoBean.bccs}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Title</FormLabel>
          </Col>
          <Col sm="8">
            <InputTextbox
              name="title"
              value={mailInfoBean.title}
              onChange={this.mailOnChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Attachments</FormLabel>
          </Col>
        </Row>
        <Row>
          <textarea
            name="message"
            value={mailInfoBean.message}
            onChange={this.mailOnChange}
            style={textAreaStyle}
            className="form-control"
            type="text"
          />
        </Row>
      </div>
    );
  }
}
function CustomerTransactionInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerTransaction {...props} name="" /> <br />
    </div>
  );
}

export default CustomerTransactionInquiry;
